import React, { useCallback, useState } from 'react';
import { useIntl } from '@leagueplatform/locales';
import { useGetIsImpersonator } from '@leagueplatform/auth-utils';
import { ErrorState } from 'components/error/error-state.component';
import { ERROR_TYPES } from 'hooks/use-error-message/use-error-message';
import { IframeModal } from 'components/iframe-modal/iframe-modal.component';
import { LoadingSpinner } from 'components/spinner/loading-spinner.component';
import { useAuthedWebviewModal } from 'hooks/use-authed-webview-modal/use-authed-webview-modal.hook';
import { ImpersonationErrorDisplayModalComponent } from '../impersonation-error/impersonation-error-display-modal.component';

export const AuthedWebviewModal = React.memo(() => {
  const isImpersonation = useGetIsImpersonator();

  const [iframeRef, setIframeRef] = useState<HTMLIFrameElement | null>(null);
  const iframeCallbackRef = useCallback((node: HTMLIFrameElement) => {
    if (node !== null) setIframeRef(node);
  }, []);

  const { closeModal, isOpen, url, error, isLoading } =
    useAuthedWebviewModal(iframeRef);

  const { formatMessage } = useIntl();

  if (!isOpen || !url) return null;

  if (isImpersonation) {
    return (
      <ImpersonationErrorDisplayModalComponent
        isOpen={isOpen}
        onClose={closeModal}
      />
    );
  }

  const modalTitle = formatMessage({ id: 'AUTHED_WEBVIEW_MODAL_TITLE' });

  return (
    <IframeModal onClose={closeModal}>
      {error ? (
        <ErrorState
          errorType={ERROR_TYPES.API_ERROR}
          hideButton
          styleProps={{ height: '100%' }}
        />
      ) : (
        <>
          {isLoading && <LoadingSpinner />}
          <iframe
            id="authedWebviewModal"
            ref={iframeCallbackRef}
            height="100%"
            width="100%"
            title={modalTitle}
            src={url}
          />
        </>
      )}
    </IframeModal>
  );
});
